import { Link } from "react-router-dom";

// Petal mark (used on the payment page). Multicolour to match the brand logo.
export function LogoMark({ className = "" }) {
  const petals = ["#1ba7e0", "#e6007e", "#fdec44", "#80d2ea", "#ff8e4c"];
  const angles = [-62, -31, 0, 31, 62];
  return (
    <svg viewBox="0 0 100 100" className={className} role="img" aria-label="NEAD">
      {angles.map((a, i) => (
        <ellipse key={i} cx="50" cy="45" rx="7.8" ry="27" fill={petals[i]} transform={`rotate(${a} 50 79)`} />
      ))}
      <circle cx="50" cy="79" r="14" fill="#1b2155" />
      <circle cx="50" cy="79" r="7" fill="#ffffff" />
      <circle cx="50" cy="79" r="3.8" fill="#1b2155" />
    </svg>
  );
}

export default function Logo({ className = "", imgClassName = "h-9" }) {
  return (
    <Link to="/" className={`flex items-center ${className}`} data-testid="logo-home-link">
      <img src="/nead-logo.png" alt="NEAD, Northern Equality and Diversity CIC" className={imgClassName} />
    </Link>
  );
}
